import serviceRequest from "utils/request";

const baseUrl = "/api/information";

export const getServiceAgreements = (serviceId) =>
	serviceRequest({
		url: `${baseUrl}/service-agreements`,
		method: "get",
		params: { serviceId },
	});

export const createServiceAgreement = (data) =>
	serviceRequest({
		url: `${baseUrl}/service-agreements`,
		method: "post",
		data,
	});
